<template>
    <b-form class="d-flex flex-column gap-sm">
		<b-form-row>
			<b-col>
				<label for="nomeDoArquivo">Arquivo:</label>
				<b-form-file required placeholder="Selecione um arquivo..." browse-text="Pesquisar" v-model="arquivoSelecionado" accept="application/vnd.ms-powerpoint , application/pdf , application/x-rar-compressed"></b-form-file>
			</b-col>
		</b-form-row>
		<b-form-row>
			<b-col>
				<label for="descricao">Descrição:</label>
				<b-form-textarea
      			id="descricao"
      			v-model="descricao"
      			placeholder="Descrição"
    		></b-form-textarea>
			</b-col>
		</b-form-row>
		<b-form-row>
			<div id="enviarArquivo" tabindex="0" class="d-inline-block ml-1">
				<b-button variant="success" @click="salvarNovoArquivo" :disabled="carregando || arquivoSelecionado == null">
					<b-spinner v-show="carregando" variant="light"></b-spinner>
					<span v-show="!carregando" >
						Enviar
					</span>
					<b-tooltip target="enviarArquivo" v-if="arquivoSelecionado == null">Selecione um arquivo</b-tooltip>
				</b-button>
			</div>
		</b-form-row>
	</b-form>
</template>

<script>
import ArquivoUsuarioService from "../../service/ArquivoUsuarioService.js";

export default {
	name: "SalvarArquivosUsuario",
	props: [ "usuario" ],
	data() {
		return {
			arquivoSelecionado: null,
			descricao: "",
			carregando: false,
		};
	},
	methods: {
		salvarNovoArquivo() {
			this.carregando = true;
			const form = new FormData();
			form.append("arquivo", this.arquivoSelecionado);
			form.append("descricao", this.descricao);
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			ArquivoUsuarioService.salvarNovoArquivo(this.usuario.id, form, usuarioLogado.id)
				.then(() => {
					this.mensagem("Arquivo Enviado Com Sucesso!", "Sucesso", "success");
					this.limparFormulario();
				}).catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível realizar o upload do arquivo!", "Erro", "danger");
					}
				}).finally(() => {
					this.carregando = false;
				});
		},
		limparFormulario() {
			this.arquivoSelecionado = null;
			this.descricao = "";
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosUsuarios/SalvarArquivosUsuario.vue